import { render, staticRenderFns } from "./ShadowIcon.vue?vue&type=template&id=3a3c904c&"
import script from "./ShadowIcon.vue?vue&type=script&lang=js&"
export * from "./ShadowIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports